// Verbal operant color mapping — per BCBA discrimination-card convention.
// Reference: Tact = green, Listener = red, Imitation = sky, Intraverbal = purple,
// Echoic = yellow, Textual = slate (kept distinct so BCBAs can still add these cards).
export const VERBAL_OPERANTS = [
  "Tact",
  "Echoic",
  "Intraverbal",
  "Listener",
  "Textual",
  "Imitation",
];

export const OPERANT_COLORS = {
  Tact:        { bg: "#DCFCE7", border: "#16A34A", text: "#15803D", ring: "rgba(22,163,74,0.20)" },
  Listener:    { bg: "#FEE2E2", border: "#DC2626", text: "#991B1B", ring: "rgba(220,38,38,0.22)" },
  Imitation:   { bg: "#BAE6FD", border: "#0284C7", text: "#0369A1", ring: "rgba(2,132,199,0.22)" },
  Intraverbal: { bg: "#F3E8FF", border: "#A855F7", text: "#7E22CE", ring: "rgba(168,85,247,0.22)" },
  Echoic:      { bg: "#FEF08A", border: "#CA8A04", text: "#854D0E", ring: "rgba(202,138,4,0.22)" },
  Textual:     { bg: "#E2E8F0", border: "#475569", text: "#1E293B", ring: "rgba(71,85,105,0.22)" },
};

export function operantColor(op) {
  return OPERANT_COLORS[op] || { bg: "#F1F5F9", border: "#94A3B8", text: "#334155", ring: "rgba(148,163,184,0.18)" };
}
